import { CubeTimeDimensionGranularity } from '../../../enum/cube-schema.enum';

export interface QueryUserMaxAppMetricsRequestParamsDto {
  appIds: string[];
  granularity?: CubeTimeDimensionGranularity;
}
